import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function CardInformation() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Card Information"
            breadcrumbItem="Card Information"
          />
          <h4>Card Information</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CardInformation;
